import { store } from "@/store"

import {
  CALL_SUPPORT_PHONE_NUMBER,
  CALL_SUPPORT_NUMBER,
  HELP_SUPPORT,
  ORDER_SUMMARY,
  MY_ACCOUNT_ORDERS,
  MY_ACCOUNT,
} from "@/components/Shared/CustomerSupport/analytics/constants"
import {
  CUSTOMER_SUPPORT,
  LANDING,
} from "@/components/checkout/v2/analytics/constants"
import { calculateCartData } from "@/utils/helper"

const pushAnalyticsObjToDataLayer = async (eventInfo = {}, cartObj = {}) => {
  const event = "cmp:click"
  const page = window.pageObj || {}

  if (cartObj) {
    const cartData = await calculateCartData({ cart: cartObj }, true)
    page.cart = cartData.cart
  }

  if (page?.cartInfo?.cartItems === "") {
    page.cart.item = []
    if (page.productInfo) {
      delete page.productInfo
    }
  }

  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}

export const addAnalyticsCallSupportNumber = (e, name) => {
  const { cart: { cart: cartObj = {} } = {} } = store?.getState() || {}

  if (!e?.target?.innerText) return
  const innerText = e.target.innerText
  let eventInfo = {}
  const isEmail = innerText.toLowerCase().includes("email")
  const isOrderSupport = name === "order"
  const actionValue = isEmail
    ? innerText.toLowerCase()
    : isOrderSupport
    ? CALL_SUPPORT_NUMBER
    : CALL_SUPPORT_PHONE_NUMBER

  const defaultEventInfo = {
    clickInternalLinks: "true",
    eventAction: `${name}:${LANDING}:${actionValue}`,
    eventMsg: "n/a",
    eventName: `${name}:${LANDING}:${actionValue}`,
    eventStatus: "n/a",
    eventType: `${HELP_SUPPORT}`,
    internalLinkName: isEmail ? innerText.toLowerCase() : innerText,
    internalLinkPosition: name,
    internalLinkType: `${name}:navigation`,
    internalLinkURL: isEmail ? e?.target?.href : `tel:${innerText}`,
    internalLinkZoneName: `${name}:${LANDING}:${CUSTOMER_SUPPORT}`,
  }
  const orderEventInfo = {
    clickInternalLinks: "true",
    eventAction: `${MY_ACCOUNT_ORDERS}:${ORDER_SUMMARY}:${actionValue}`,
    eventMsg: "n/a",
    eventName: `${MY_ACCOUNT_ORDERS}:${ORDER_SUMMARY}:${actionValue}`,
    eventStatus: "n/a",
    eventType: `${HELP_SUPPORT}`,
    internalLinkName: isEmail ? innerText.toLowerCase() : innerText,
    internalLinkPosition: MY_ACCOUNT,
    internalLinkType: "my account:orders:order details:customer support",
    internalLinkURL: isEmail ? e?.target?.href : `tel:${innerText}`,
    internalLinkZoneName: "my account:orders:order details:customer support",
  }

  eventInfo = isOrderSupport ? orderEventInfo : defaultEventInfo

  pushAnalyticsObjToDataLayer(eventInfo, cartObj)
}
